import React from 'react';
import VideoLinkPageTemplate from './VideoLinkPageTemplate';
import ProjectDetails from './ProjectDetails';
import OffTheDeckStill from '../assets/images/OfftheDeckStill.png';

function OffTheDeckPage() {
  const title = 'OFF THE DECK (2026)';
  const subtitle = 'Short Film, 17 mins';
  const description = 'A young DJ begins to face a rift in his personal life upon meeting an enigmatic manager, who tries to promote his services online.';
  const festivals = [
    'Alexandria Film Festival 2026',
    'Charlottesville Indie Film Festival 2026',
  ];
  const credits = [
    { role: 'Writer, Director', names: ['Kenneth Nguyen'] },
    { role: 'Producers', names: ['Rowan Rosenblum', 'Tiernan Caulfield'] },
    { role: 'Director of Photography', names: ['Tiernan Caulfield'] },
    { role: 'Music by', names: ['Vincent Nguyen', 'Justin Tyrell', 'Jonny Cody'] },
  ];
  const cast = [
    { role: 'Quentin', name: 'Jaden Kilkenny' },
    { role: 'Oliver', name: 'Gabriel Mayor-Mora' },
    { role: 'June', name: 'Summer Serafim' },
  ];

  return (
    <main>
      <VideoLinkPageTemplate
        title={title}
        subtitle={subtitle}
        description={description}
        imageSrc={OffTheDeckStill}
      />
      <ProjectDetails festivals={festivals} credits={credits} cast={cast} />
    </main>
  );
}

export default OffTheDeckPage;
